__turbopack_context__.v({
  "chipButton": "styles-module__CnHRBa__chipButton",
});
